import React, { useMemo, useRef, useState } from 'react'
import parse from 'html-react-parser'
import { Typography } from 'shared/ui'
import { type CannedMessage } from 'entities/CannedMessages/model/CannedMessage'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { IconSharedSavedReply } from 'entities/CannedMessages'
import { useMergeFields } from 'widgets/MergeField'
import { Attachments, textToHtml } from 'widgets/MessageField'
import { useSavedRepliesContext } from 'widgets/SavedReplies/context'
import styles from './styles.module.scss'

export const SavedReplySelectedItem = () => {
  const { selectedSavedReply } = useSavedRepliesContext()
  const [trigger, setTrigger] = useState<HTMLDivElement | null>(null)
  const ref = useRef(null)
  const entities = useEntitiesContext()
  const message = useMemo(() => {
    if (selectedSavedReply?.message) {
      return parse(
        textToHtml(entities, {
          text: selectedSavedReply.message,
          replaceNewRow: true,
        })
      )
    }
  }, [selectedSavedReply])

  const { onHideMergeFieldsTooltips, mergeFieldTooltipComponent } = useMergeFields<CannedMessage>({
    trigger,
    updateTriggerDeps: [selectedSavedReply, trigger],
  })

  const onScroll = () => {
    onHideMergeFieldsTooltips()
  }

  return (
    <div className={styles.wrap} ref={ref}>
      <div className={styles.wrapContent} ref={setTrigger}>
        {mergeFieldTooltipComponent}
        <Typography
          variant={'body-rg-medium'}
          className={styles.title}
          tag={'div'}
          ariaLabel={'title'}
        >
          {selectedSavedReply?.title}
          <IconSharedSavedReply savedReply={selectedSavedReply} className={styles.titleIcon} />
        </Typography>

        {!!selectedSavedReply?.attachments?.length && (
          <div className={styles.wrapAttachments}>
            <Attachments attachments={selectedSavedReply.attachments} />
          </div>
        )}
        <Typography
          variant={'body-rg-regular'}
          className={styles.message}
          tag={'div'}
          onScroll={onScroll}
          ariaLabel={'message'}
        >
          {message}
        </Typography>
      </div>
    </div>
  )
}
